// B — Passage / 三道光: a deterministic architectural camera, no playback inertia.
import {createArchitecture} from './architecture.js';
const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
const smooth=v=>{v=clamp(v);return v*v*(3-2*v);};
const mix=(a,b,p)=>a+(b-a)*p;
export function createB({THREE:T,scene,camera,renderer,portrait=false}) {
  const architecture=createArchitecture({THREE:T,scene,portrait});
  let isPortrait=!!portrait,time=0;
  const duration=6.8,travelEnd=6.0;
  const curves={
    desktop:new T.CatmullRomCurve3([[.10,1.56,19.1],[.08,1.60,16],[.05,1.62,12.5],[.09,1.64,9.2],[.06,1.65,6],[.12,1.67,2.9],[.35,1.68,.55]].map(p=>new T.Vector3(...p)),false,'centripetal'),
    portrait:new T.CatmullRomCurve3([[-.10,1.53,20],[-.12,1.56,16.4],[-.13,1.60,12.9],[-.08,1.60,9.25],[-.04,1.61,6.25],[.08,1.62,3.1],[.15,1.62,.85]].map(p=>new T.Vector3(...p)),false,'centripetal')
  };
  for(const curve of Object.values(curves)){curve.arcLengthDivisions=400;curve.updateArcLengths();}
  function update(seconds) {
    time=clamp(seconds,0,duration);
    const progress=smooth(time/travelEnd),end=architecture.finalCamera(isPortrait);
    const position=(isPortrait?curves.portrait:curves.desktop).getPointAt(progress),settle=smooth((progress-.73)/.27);
    const target=new T.Vector3(mix(position.x+.025,end.target[0],settle),mix(1.70,end.target[1],settle),mix(position.z-7.8,end.target[2],settle));
    if(time>=travelEnd){position.set(...end.position);target.set(...end.target);}
    camera.position.copy(position);camera.lookAt(target);
    const fov=isPortrait?mix(53,end.fov,smooth(progress)):mix(42,48,smooth(progress))+Math.sin(Math.PI*progress)*2;
    const nextFov=time>=travelEnd?end.fov:fov;
    if(camera.fov!==nextFov){camera.fov=nextFov;camera.updateProjectionMatrix();}
    renderer.toneMappingExposure=mix(.72,1.08,smooth(progress));
    architecture.update({surface:1,line:0,light:mix(.86,1,smooth(progress/.75)),time});
    scene.userData.intro={variant:'B',time,progress,phase:time<1.45?'approach':time<5.15?'passage':time<6?'arrival':'hold',doorwaysPassed:[11.8,7.2,2.3].filter(z=>position.z<z).length};
  }
  function resize(value){isPortrait=!!value;update(time);camera.updateProjectionMatrix();}
  update(0);
  return {duration,update,resize,dispose(){architecture.dispose();},inspect(){return {...scene.userData.intro,portrait:isPortrait,camera:{position:camera.position.toArray(),target:time>=travelEnd?architecture.finalCamera(isPortrait).target:null,fov:camera.fov},architecture:architecture.inspect()};}};
}
